"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AvatarActions;
(function (AvatarActions) {
    AvatarActions["ImageLoaded"] = "ImageLoaded";
    AvatarActions["LargeImageShown"] = "LargeImageShown";
    AvatarActions["LargeImageHidden"] = "LargeImageHidden";
})(AvatarActions || (AvatarActions = {}));
exports.default = AvatarActions;
